<template >  
<div>
    <div v-if="loading" class="loader">
        <v-progress-circular
            :size="80"
            :width="8"
            color="#6FB793"
            indeterminate
        ></v-progress-circular>        
    </div>
    
    <div v-else class="flex location-filter"> 
        <div class="flex locations-con">    
            <div class="loc" v-for="item in statedata" :key="item.id">
                <div class="flex location">
                    <v-checkbox 
                        v-model="selectedStateIds"
                        background-color="white" 
                        class="state_name" 
                        :label="capitalizeFirstLetter(item.eng_name)" 
                        hide-details color="success" 
                        :value = item.id
                    />
                </div>
            </div>
        </div> 
        
        <div class="flex filter-buttons">
            <button class="clear" @click="handleClearBtn">Clear</button>
            <button class="done" @click="handleDoneBtn">Done</button>
        </div>
    </div>
</div>
</template>


<script>
import checkboxitem from "./checkboxitem";
import API_URL from "../../../../helpers/apiUrls";
import { mapActions } from "vuex";

export default {
    ...mapActions(["queryStore", "removestateid", "addstatedata", "GET_STATE_ID"]),
    name: "locations",
    data () {
        return { 
            statedata : [],
            checkbox: false,
            selectedStateIds : [],
            clickedstates : [],
            storedata : [],
            checkbox : true,
            loading : false,
            // removedStates : ['', ''],
            removedState1 : "52b667cb-16a3-41c7-8654-94ae81740e28",
            removedState2 : "933488d8-15f6-4dd4-9c36-c7986a427ead",
        }
    },
    components: {
        "checkboxitem": checkboxitem,
    },

    mounted(){
        this.getStateKey(),
        this.getCheckedState()
    },


    methods:{
        handleClearBtn(){
            this.$store.dispatch('queryStore/removestateid');
            this.selectedStateIds = []
            this.$emit('clearlocation')
        },
        handleDoneBtn(){
            this.$store.dispatch('queryStore/addstatedata', { stateid: this.selectedStateIds}); 
            this.$emit('applylocation')
        }, 

        // get already checked states from store
        getCheckedState(){
            this.selectedStateIds = this.$store.getters["queryStore/GET_STATE_ID"]; 
        },

        capitalizeFirstLetter(string) {
            var str = string.toLowerCase();
            return str.charAt(0).toUpperCase() + str.slice(1);
        },

        // get list of states ans key
        getStateKey(){
            this.loading = true;
            const successHandler = response => {
                if(response.status === 200) {
                    this.statedata = response.data.results;
                    this.loading = false;
                }
                this.statedata = this.statedata.filter(
                    (item) => item.id !== this.removedState1 
                )
                this.statedata = this.statedata.filter(
                    (item) => item.id !== this.removedState2
                )
            }

            const errorHandler = response => {
                this.showToast('Something went wrong internally!', 'error', 10000);
                this.loading = false;
            }

            this.requestGET(
                `${API_URL.getStatesQuery}`,
                {},
                {},
                successHandler,
                errorHandler,
            )             
        }
    }
}
</script>


<style lang="scss" scoped>
.loader{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 370px;
    background-color: #ffffff;
}
.location-filter{
    width: 440px;
    flex-direction:column;
    background-color: #ffffff;
    padding: 15px;
}
.locations-con{
    flex-wrap: wrap;
    justify-content: space-between;
    border: 0.5px solid #BFBFBF;
    max-height: 370px;
    overflow: scroll;
    overflow-x: hidden;
    max-width: 400px;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 20px;
}
.location{
    column-gap: 8px;
    width: 166px;
    justify-content: start;    
}

.state_name{
    justify-content: flex-start;
    overflow: hidden;
    cursor: pointer;
}
.v-input--selection-controls{
    margin-top: 6px;
}

.location-item{
    margin: 0px;
}
.v-application p {
    margin-top: 6px;
    font-size: 0.9rem;
    margin-bottom: 0px;
}
.filter-buttons{
    width: 100%;
    column-gap: 20px;

    button{
        padding: 15px 20px;
        border-radius: 5px;
        font-size: 0.8rem;
        font-weight: 500;
    }
}
.clear{
    background-color: rgba(57, 186, 123, 0.11);
    width: 50%;
    color: #328736;
}
.done{
    background-color: #36983B;
    width: 50%;    
    color: #fff;
}
.v-input--selection-controls .v-input__slot > .v-label{
    font-weight: 400 !important;
}
.v-input__control .v-label {
  color: red;
}
</style>
<style >
.location-filter .v-btn__content {
    text-transform: capitalize !important;
}
.location-filter .v-input__slot > .v-label{
    font-weight: 400 !important;
    color: #5B5B5B !important;
}

</style>
